export const LNRABI = [
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'symbol',
        type: 'bytes32',
      },
    ],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
];
